import React from 'react' 

export const Settings: React.FC = () => {
    return (
        <h1>Nastaveni</h1>
    )
}